import LabServiceModel from "@/models/LabServiceModel";
import TestPackageSampleModel from "./TestPackageSampleModel";
import AnalyteModel from "./AnalyteModel";

export default class TestPackageAnalyteModel extends LabServiceModel {

  modelName() {
    return 'test-package-analyte';
  }

  defaults() {
    return {
      id: null,
      test_package_sample_id: null,
      test_package_sample: null,
      analyte_id: null,
      analyte: null,
      name: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      test_package_sample_id: (val) => (this.nullStringMutator(val)),
      test_package_sample: Object,
      analyte_id: (val) => (this.nullStringMutator(val)),
      analyte: Object,
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getTestPackageSample() {
    return this.getRelatedModel(TestPackageSampleModel, 'test_package_sample');
  }

  getAnalyte() {
    return this.getRelatedModel(AnalyteModel, 'analyte');
  }

}
